import { Component, input, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'matchmaking-info-box',
    imports: [],
    templateUrl: './info-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './info-box.component.scss'
})
export class InfoBoxComponent {
    title = input.required<string>()
    description = input.required<string>()
    imageSrc = input.required<string>()
}
